import { styled, CSSObject, alpha, styled as muiStyle } from "@mui/material/styles";
/* types */
import { StyledBoxProps, StyledSpinnerProps } from "../";
import { BoxProps as MuiBoxProps, CircularProgress } from "@mui/material";
export type ExtendedBoxProps = MuiBoxProps & StyledBoxProps;

/* components */
import { Box as MuiBox } from '@mui/material';

/* styled */


const variantMixin = ({ theme, variant, color }: any): CSSObject => ({
  ...(variant === `outlined` && {
    border: `1px solid`,
    borderColor: theme.palette[color].light,
    backgroundColor: theme.palette[color].contrastText,
    ...(color === 'default' && {
      borderColor: theme.palette.divider,
    }),
  }),
  ...(variant === `contained` && {
    backgroundColor:  alpha(theme.palette[color].main, 0.08),
  }),
});

export const Spinner = styled(CircularProgress)<StyledSpinnerProps>(({theme})=> ({
  position: `absolute`,
  left: `50%`,
  top: `50%`,
  margin: `-12px 0 0 -12px`,
  color: theme.palette.grayscaleSecondary[200]
}));

export const StyledBox = styled(MuiBox, {
  shouldForwardProp: (prop) => !['loading', 'disabled', 'radius', 'padding', 'width', 'loadingSize', 'htmlColor'].includes(String(prop)), //(prop) => prop !== 'circled' && prop !== 'loading',
})<ExtendedBoxProps>(({ theme, variant, color, disabled, radius,htmlColor, loadingSize, padding, width, loading}) => ({
  boxSizing: `border-box`,
  borderRadius: `${radius}px`,
  padding: padding? padding : '0',
  width: width? width : '100%',
  ...(color !== undefined && color !== `inherit` && variant !== undefined && variantMixin({ theme, variant, color })),

  ...(disabled && {
    position: `relative`,
    '&:after': {
      content: '""',
      display: `block`,
      position: `absolute`,
      left: `0`,
      top: `0`,
      width: `100%`,
      height: `100%`,
      borderRadius: `${radius}px`,
      backgroundColor: alpha(theme.palette.common.white, 0.5)
    }
  }),
  ...(loading && {
    position: `relative`,
    '&:after': {
      content: '""',
      display: `block`,
      position: `absolute`,
      left: `0`,
      top: `0`,
      width: `100%`,
      height: `100%`,
      borderRadius: `${radius}px`,
      backgroundColor: alpha(theme.palette.common.white, 0.5)
    },
    '.MuiCircularProgress-root': {
      zIndex: 1
    }
  }),
  ...(htmlColor && {
    backgroundColor: htmlColor
  }),
}));
